export const SET_AGREED_TO_TERMS = 'SET_AGREED_TO_TERMS';
export const RESET_AGREED_TO_TERMS = 'RESET_AGREED_TO_TERMS';

export type SetAgreedToTermsAction = {
	type: typeof SET_AGREED_TO_TERMS;
	payload: boolean;
};

export type ResetAgreedToTermsAction = {
	type: typeof RESET_AGREED_TO_TERMS;
};

export type AgreedToTermsActionTypes = SetAgreedToTermsAction | ResetAgreedToTermsAction;
